import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import React from 'react';
import styled from 'styled-components';
const { font_color_white } = variables;

interface ClampContainerProps {
  lines?: number;
  wordBreak?: 'break-all' | 'break-word';
}

export const ClampContainerMixin = ({
  lines = 1,
  wordBreak = 'break-word'
}: ClampContainerProps) => `
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: ${wordBreak};
  -webkit-perspective: 1000px;
`;

export const ClampContainer = styled.span<ClampContainerProps>`
  ${({ lines, wordBreak }) => ClampContainerMixin({ lines, wordBreak })}
`;
const ParagraphSizeMap = { 1: 20, 2: 18, 3: 14 };
export const ParagraphMixin = ({ size = 1 }: { size?: number }) => `
  user-select: none;
  font-family: 'Default-Font';
  font-weight: normal;
  color: ${font_color_white};
  font-size: ${getScalablePixel(ParagraphSizeMap[size])}px;
`;

GlobalStyle.inject`
  p {
    font-weight: normal;
    color: ${font_color_white};
    margin: 0;
  }
  .p1 {
    ${ParagraphMixin({ size: 1 })}
  }

  .p2 {
    ${ParagraphMixin({ size: 2 })}
  }

  .p3 {
    ${ParagraphMixin({ size: 3 })}
  }

  h1, h2, h3, h4 {
    font-weight: bold;
    color: ${font_color_white};
    margin: 0;
  }

  .h1 {
    font-size: ${getScalablePixel(54)}px;
  }

  .h2 {
    font-size: ${getScalablePixel(27)}px;
  }

  .h3 {
    font-size: ${getScalablePixel(23)}px;
  }

  .h4 {
    font-size: ${getScalablePixel(20)}px;
  }
`;

export const P1 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLParagraphElement>>) => (
  <p {...props} className={'p1 ' + (props.className || '')} />
);

export const P2 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLParagraphElement>>) => (
  <p {...props} className={'p2 ' + (props.className || '')} />
);

export const P3 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLParagraphElement>>) => (
  <p {...props} className={'p3 ' + (props.className || '')} />
);

export const H1 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>>) => (
  <h1 {...props} className={'h1 ' + (props.className || '')} />
);

export const H2 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>>) => (
  <h2 className={'h2 ' + (props.className || '')} {...props} />
);

export const H3 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>>) => (
  <h3 className={'h3 ' + (props.className || '')} {...props} />
);

export const H4 = (props: React.PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>>) => (
  <h4 className={'h4 ' + (props.className || '')} {...props} />
);
